<template lang="pug">
//- b-input-group(:prepend="$t('ui.date')" size="sm")
b-input-group(:prepend="!removePrepend ? $t('ui.date') : ''" size="sm")
  date-range-picker(
    ref="picker"
    v-model="dateRange"
    :opens="opens"
    :singleDatePicker="singleDatePicker"
    :showWeekNumbers="showWeekNumbers"
    :autoApply="autoApply"
    :linkedCalendars="linkedCalendars"
    @update="handleInput"
    timePicker=true
    timePicker24Hour=true
    timePickerSeconds=true
    :timePickerIncrement="minuteStep"
    :showDropdowns="true"
    :ranges="ranges"
    :class="{ 'w-100' : removePrepend }"
  )
    div(slot="input" slot-scope="dateRange" style="min-width:170px;")
      i.glyphicon.glyphicon-calendar.fa.fa-calendar.mr-3
      span.text-right {{ $moment(dateRange.startDate).format('YYYY-MM-DD HH:mm:ss') }} - {{ $moment(dateRange.endDate).format('YYYY-MM-DD HH:mm:ss') }}
    //- ranges (new slot syntax)
    template(#ranges='ranges')
      .ranges
        ul
          template(v-for='(range, name, index) in ranges.ranges')
            //- li(v-if="!['This year'].includes(name)" :key='name' @click='ranges.clickRange(range)')
            //-   span {{ showLabel(index) }}
            li(v-if="!['This year'].includes(name)" :key='name', @click='onRangeClick(range)')
              span {{ showLabel(index) }}

</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';

export default {
  components: {
    DateRangePicker
  },
  props: {
    opens: {
      type: String,
      default: "right"
    },
    singleDatePicker: {
      type: Boolean,
      default: false
    },
    showWeekNumbers: {
      type: Boolean,
      default: false
    },
    linkedCalendars: {
      type: Boolean,
      default: true
    },
    autoApply: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: "YYYY-MM-DD HH:mm:ss"
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    value: {
      type: Object,
      default: null
    },
    removePrepend: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateRange: this.value,
      // ranges: {
      //   'Today': [this.$moment().format('YYYY-MM-DD 00:00:00'), this.$moment().format('YYYY-MM-DD 23:59:59')],
      //   'Yesterday': [this.$moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00'), this.$moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59')],
      //   'This month': [this.$moment().startOf('month'), this.$moment().endOf('month')],
      //   // 'This year': [this.$moment().startOf('year'), this.$moment().endOf('year')],
      //   'Last week': [this.$moment().subtract(1, 'week').startOf('week').add(1, 'days'), this.$moment().subtract(1, 'week').endOf('week').add(1, 'days')],
      //   'Last month': [this.$moment().subtract(1, 'month').startOf('month'), this.$moment().subtract(1, 'month').endOf('month')],
      // },
      ranges: {
        'Today': [
          this.$moment().startOf("day").toDate(),
          this.$moment().endOf("day").set({ hour: 23, minute: 59, second: 59 }).toDate()
        ],
        'Yesterday': [
          this.$moment().subtract(1, "days").startOf("day").toDate(),
          this.$moment().subtract(1, "days").endOf("day").set({ hour: 23, minute: 59, second: 59 }).toDate()
        ],
        "This Month": [
          this.$moment().startOf("month").toDate(),
          this.$moment().endOf("month").toDate()
        ],
        'This year': [
          this.$moment().startOf('year').toDate(),
          this.$moment().endOf('year').set({ hour: 23, minute: 59, second: 59 }).toDate()
        ],
        "Last Month": [
          this.$moment().subtract(1, "month").startOf("month").toDate(),
          this.$moment().subtract(1, "month").endOf("month").toDate()
        ],
      }
      // locale: {
      //   format: 'M/DD hh:mm A'
      // }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    showLabel(item) {
      return this.$t('ui.date_ranges.' + item);
    },
    handleInput: function(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD HH:mm:ss');
      // this.$store.dispatch("layout/setDateRange", this.dateRange);
      this.$emit("update", currentValue);
    },
    onRangeClick(range) {
      // Set Date in Date Range Picker display
      this.$refs.picker.clickRange(range);

      // Set Time in Time Picker Display (Dropdown select option)
      // Have to manually change the dropdown display this way, because current library does not support
      const startHSelectEl = document.querySelectorAll(".hourselect")[0];
      startHSelectEl.value = 0
      const startMSelectEl = document.querySelectorAll(".minuteselect")[0];
      startMSelectEl.value = 0
      const startSSelectEl = document.querySelectorAll(".secondselect")[0];
      startSSelectEl.value = 0

      const endHSelectEl = document.querySelectorAll(".hourselect")[1];
      endHSelectEl.value = 23
      const endMSelectEl = document.querySelectorAll(".minuteselect")[1];
      endMSelectEl.value = 59
      const endSSelectEl = document.querySelectorAll(".secondselect")[1];
      endSSelectEl.value = 59
    }
  }
};
</script>